import React from 'react';
import { styles } from './styles'; // 引入样式

export default function CenterPanel({ state, event, isGenerating, isMobile, choose, hackState, hackStateRef, setHackState, handleHackResult, logs, terminalEndRef }) {
    return (
        <div className="center-panel">
            <h2 style={{ margin: '0 0 10px 0', color: '#fff' }}>
                Vibe Coding 纪元 - {2022 + Math.floor(state.gameMonths / 12)}年{(state.gameMonths % 12) + 1}月
            </h2>

            {/* 突发事件面板 */}
            <div style={styles.eventCard}>
                {isGenerating ? (
                    <div style={{ textAlign: 'center', padding: '40px 0', color: '#ff9800' }}>
                        <div className="loading-spinner">⚙️</div>
                        <h3 className="blink-text">系统正在推演未来局势...</h3>
                        <p style={{ color: '#666', fontSize: 13 }}>等待大模型生成动态事件</p>
                    </div>
                ) : event.type === 'normal' ? (
                    <>
                        <h3 style={{ marginTop: 0, color: '#fff' }}>{event.title}</h3>
                        <p style={{ lineHeight: 1.6, color: '#ccc', minHeight: 60 }}>{event.description}</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 20 }}>
                            {event.choices.map((c, i) => (
                                <button key={i} style={styles.btnAction} onClick={() => choose(c)}>{c.text}</button>
                            ))}
                        </div>
                    </>
                ) : null}
            </div>

            {/* 终端日志面板 */}
            <div style={{ ...styles.terminal, height: isMobile ? '35vh' : 'auto', maxHeight: isMobile ? '300px' : 'none', marginBottom: isMobile ? 10 : 20 }}>
                <div style={{ ...styles.terminalHeader, background: hackState ? '#f44336' : '#222', color: hackState ? '#fff' : '#aaa' }}>
                    {hackState ? "⚠️ HACK OVERRIDE PROTOCOL ACTIVE" : "root@ma-jian-os:~# tail -f /var/log/decisions.log"}
                </div>
                <div style={{ ...styles.terminalBody, flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
                    {hackState ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '5px 0' }}>
                            {/*...Hack 输入框保持原有...*/}
                            <div style={{ color: '#f44336', fontWeight: 'bold', fontSize: 16, animation: 'blink 1s infinite' }}>🚨 OVERRIDE REQUIRED: {hackState.time}s</div>
                            <div style={{ background: '#111', padding: '10px', borderRadius: 4, fontFamily: 'monospace', letterSpacing: 1, lineHeight: 1.5 }}>
                                {hackState.target.split('').map((char, i) => {
                                    const isTyped = i < hackState.input.length;
                                    const isCorrect = isTyped && hackState.input[i] === char;
                                    const isWrong = isTyped && !isCorrect;
                                    let color = '#555', bg = 'transparent';
                                    if (isCorrect) color = '#0f0';
                                    if (isWrong) { color = '#fff'; bg = '#f44336'; }
                                    return <span key={i} style={{ color, background: bg }}>{char}</span>;
                                })}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <span style={{ marginRight: 8, color: '#fff', fontSize: 14 }}>root@sys:~#</span>
                                <input autoFocus value={hackState.input} onPaste={(e) => e.preventDefault()}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === hackStateRef.current.target) handleHackResult(true, { ...hackStateRef.current, input: val });
                                        else setHackState(prev => ({ ...prev, input: val }));
                                    }}
                                    style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', color: '#0f0', fontFamily: 'monospace', fontSize: 15 }} spellCheck={false} autoComplete="off" />
                            </div>
                        </div>
                    ) : (
                        <>
                            {logs.map(log => <div key={log.id} style={{ color: log.color, marginBottom: 4 }}>{log.text}</div>)}
                            <div ref={terminalEndRef} />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}